// import ReportTransferAnalysis from '../components/ui/report-transfer-analysis.js';
import CurrentCaseRequired from "../components/ui/current-case-required.js";
// import MaritalBalanceSheet from "../components/ui/marital-balance-sheet.js";
import DRFA from "../components/ui/drfa-sheet.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";

export default function DRFAReportPage(props) {
    return (
        <CaseDatabaseCheck>
        <CurrentCaseRequired>
        <DRFA/>
        </CurrentCaseRequired>
        </CaseDatabaseCheck>
    );
}